import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, List, Row, Col, Button, Modal, Divider, Space } from "antd";
import questions from "../data/questions.json";
import { clearTestStorage } from "../utils/common";
import { CONSTANTS } from "../utils/constants";
import bookImg from '../assets/BAB2E.jpg';

const TestSelection = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [test, setTest] = useState(false);

  let tests = Object.entries(questions)
  tests = tests.map(([id, test]) => ({
    id,
    title: test.title,
  }));

  const checkTest = (test) => {
    setTest(test)
    clearTestStorage();
    navigate(`/${test.id}`)
  }

  return (
    <div className="min-h-[calc(100vh-133px)] grid place-content-center place-items-center px-3">
      <Row gutter={[24, 16]}>
        <Col xs={24} md={8} className="place-content-center place-items-center mt-3 lg:mt-0">
          <img src={bookImg} className="w-7/12 lg:w-5/6 2xl:w-11/12 mx-auto" alt="Book image" />
        </Col>
        <Col xs={24} md={16}>
          <div className="flex flex-col justify-center items-center h-full text-center">
            <h1 className="text-xl lg:text-3xl 2xl:text-5xl text-[#6D6092]"><strong>{CONSTANTS.BAB1}</strong></h1>
            <h1 className="text-lg lg:text-2xl 2xl:text-4xl text-[#6D6092]"><strong>{CONSTANTS.BAB2}</strong></h1>
            <Button onClick={() => navigate('/about')} type="primary" size="large" className="my-4 !bg-[#F0DA63] !text-gray-700 hover:opacity-85 font-bold">{CONSTANTS.ABOUTBAB}</Button>
            <h2 className="text-base lg:text-xl 2xl:text-2xl">{CONSTANTS.SELECTTEST}</h2>
            <Space direction="vertical" size={'large'} className="test-btns my-4">
              {tests.map((t) => (
                <Button
                  key={t.id}
                  onClick={() => checkTest(t)}
                  type="primary"
                  block
                  size="large"
                  className="shadow-lg text-xs lg:text-base whitespace-normal"
                >
                  {t.title}
                </Button>
              ))}
            </Space>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default TestSelection;